import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Add group", -1)
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "new-choice-label" }, "Libellé du groupe", -1)

import { ref } from 'vue';
import axios from '@/api';
import Button from 'primevue/button';
import { useAlert } from '@/composables/alert';
import ActionDialog, { type ActionProps } from './ActionDialog.vue';
import type { BroadcastGroupPayload, BroadcastGroup } from '@/types/index.js';
import AppInput from './AppInput.vue';

interface ChoiceAddProps extends ActionProps {
    campaignId: ActionProps['campaignId']; // obligé de re déclarer car "extends" ou "&" ne fonctionnent pas (limitation de version Vue)
}


export default /*#__PURE__*/_defineComponent({
  props: {
    campaignId: null
  },
  emits: ["created"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'created', choice: BroadcastGroup): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    campaignId: ActionProps['campaignId']; // obligé de re déclarer car "extends" ou "&" ne fonctionnent pas (limitation de version Vue)
}





const alert = useAlert();

const newGroup = ref<BroadcastGroupPayload>({
    name: '',
});

const isOpen = ref(false);

function reset(): void {
    newGroup.value.name = '';
    alert.value = null;
}

function createGroup(): void {
    const payload: BroadcastGroupPayload = {
        name: newGroup.value.name,
    };

    axios.post(`/campaigns/${props.campaignId}/target_groups`, payload)
        .then(({ data }) => {
            emit('created', data);

            alert.value = {
                status: 'success',
                summary: 'Le groupe a été ajouté avec succès',
            };
        })
        .catch(({ response }) => {
            alert.value = {
                status: (409 === response.status) ? 'conflict' : 'error',
                detail: (409 === response.status) ? response.data['hydra:description'] : undefined
            };
        });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(createGroup, ["prevent"])
  }, [
    _createVNode(_unref(Button), {
      class: "p-button-text d-inline",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = true))
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(ActionDialog, {
      visible: isOpen.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((isOpen).value = $event)),
      header: "Ajouter un groupe de diffusion",
      alert: _unref(alert),
      "campaign-id": props.campaignId,
      onHide: reset
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(Button), {
          label: "Annuler",
          class: "p-button-text p-button-secondary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (isOpen.value = false))
        }),
        _createVNode(_unref(Button), {
          type: "submit",
          label: "Confirmer",
          disabled: '' === newGroup.value.name.trim()
        }, null, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(AppInput, {
            id: "new-choice-label",
            modelValue: newGroup.value.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newGroup.value.name) = $event)),
            class: "form-control",
            autocomplete: "off",
            required: ""
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "alert", "campaign-id"])
  ], 40, _hoisted_1))
}
}

})